import { createCustomEvent } from "../../../../javascript/shared/helpers";

export default class extends Controller {
  connect() {
    this.afterUnblock  = this.afterUnblock.bind(this);
  }

  unblock(event) {
    event && event.preventDefault();
    event && event.stopPropagation();
    if (confirm("Unblock this Task?")) {
      App.Helpers.ajaxRequest({
        url:            this.url,
        method:         "PATCH",
        successHandler: this.afterUnblock
      })
    }
  }

  afterUnblock(response) {
    document.dispatchEvent(createCustomEvent("task-unblock:success", this.element, { id: this.taskID, response }));
  }

  //
  // GETTERS AND SETTERS
  //

  get taskID() {
    return this.data.get("task-id");
  }

  get url() {
    return this.element.href;
  }
};



// WEBPACK FOOTER //
// ./app/components/tasks/assets/javascript/tasks-unblock-link-controller.js